export default __webpack_public_path__ + "menu-orders-icon.d6f710a540890123a507c64ef9f4d4d7.svg";